import { Component, input, inject } from '@angular/core';
import { AsyncPipe, CommonModule } from '@angular/common';
import { MainHeaderComponent } from '@/main/main-header/main-header.component';
import { SwiperModule } from 'swiper/angular';
import { PipesModule } from '@/modules/shared/pipes/pipes.module';
import { MainService } from '@/main/services/main.service';
import { MainLoaderComponent } from '@/main/main-loader/main-loader';
import { OffersFacade } from '@/_store/offers/offers.facade';

@Component({
	selector: 'app-main-compact',
	templateUrl: './main-compact.component.html',
	standalone: true,
	imports: [MainHeaderComponent, SwiperModule, CommonModule, PipesModule, MainLoaderComponent, AsyncPipe],
})
export class MainCompactComponent {
	readonly query = input.required<string>();
	readonly title = input.required<string>();
	readonly titleSuffix = input.required<string>();

	readonly mainService = inject(MainService);
	readonly offersFacade = inject(OffersFacade);

	readonly offerList$ = this.mainService.fetchOfferListFromQuery$(this.query);
}
